<template>
  <div class="keep">
    <div class="my-chard">
      <!-- 图1 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_retaind_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">新增客户7日留存</b>
        </div>
        <span class="text">2021-06-28～2021-07-12过去15天新增客户的留存率</span>
        <div id="c1" style="margin-top: 30px"></div>
      </el-card>
      <!-- 图2 -->
      <el-card shadow="never" class="chard-box">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_lose_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">新增客户7日流失</b>
        </div>
        <span class="text">2021-06-28～2021-07-12过去15天新增客户的流失率</span>
        <!-- 表格 -->
        <div class="table1" style="margin-top: 20px">
          <el-table
            :header-cell-style="{ background: '#eeeeee', color: '#606266' }"
            :data="tableData"
            style="width: 100%"
            height="350"
            border
          >
            <el-table-column prop="date" label="总体" width="76">
            </el-table-column>
            <el-table-column prop="num" label="总人数" width="76">
            </el-table-column>
            <el-table-column prop="m1" label="第1天" width="76">
              <template slot-scope="scope">
                <span
                  :class="{
                    cellStyle: scope.row.m1 === 0 ? '' : true,
                  }"
                  ><span v-if="scope.row.m1 == 0">{{ scope.row.m1 }}</span>
                  <span v-if="scope.row.m1 !== 0">{{ scope.row.m1.n1 }}</span>
                  <span v-if="scope.row.m1 !== 0">{{
                    scope.row.m1.n2
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="m2" label="第2天" width="76">
              <template slot-scope="scope">
                <span
                  :class="{
                    cellStyle: scope.row.m2 === 0 ? '' : true,
                  }"
                  ><span v-if="scope.row.m2 == 0">{{ scope.row.m2 }}</span>
                  <span v-if="scope.row.m2 !== 0">{{ scope.row.m2.n1 }}</span>
                  <span v-if="scope.row.m2 !== 0">{{
                    scope.row.m2.n2
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="m3" label="第3天" width="76">
              <template slot-scope="scope">
                <span
                  :class="{
                    cellStyle: scope.row.m3 === 0 ? '' : true,
                  }"
                  ><span v-if="scope.row.m3 == 0">{{ scope.row.m3 }}</span>
                  <span v-if="scope.row.m3 !== 0">{{ scope.row.m3.n1 }}</span>
                  <span v-if="scope.row.m3 !== 0">{{
                    scope.row.m3.n2
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="m4" label="第4天" width="76">
              <template slot-scope="scope">
                <span
                  :class="{
                    cellStyle: scope.row.m4 === 0 ? '' : true,
                  }"
                >
                  <span v-if="scope.row.m4 == 0">{{ scope.row.m4 }}</span>
                  <span v-if="scope.row.m4 !== 0">{{ scope.row.m4.n1 }}</span>
                  <span v-if="scope.row.m4 !== 0">{{
                    scope.row.m4.n2
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="m5" label="第5天" width="76">
              <template slot-scope="scope">
                <span
                  :class="{
                    cellStyle: scope.row.m5 === 0 ? '' : true,
                  }"
                  ><span v-if="scope.row.m5 == 0">{{ scope.row.m5 }}</span>
                  <span v-if="scope.row.m5 !== 0">{{ scope.row.m5.n1 }}</span>
                  <span v-if="scope.row.m5 !== 0">{{
                    scope.row.m5.n2
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="m6" label="第6天" width="76">
              <template slot-scope="scope">
                <span
                  :class="{
                    cellStyle: scope.row.m6 === 0 ? '' : true,
                  }"
                  ><span v-if="scope.row.m6 == 0">{{ scope.row.m6 }}</span>
                  <span v-if="scope.row.m6 !== 0">{{ scope.row.m6.n1 }}</span>
                  <span v-if="scope.row.m6 !== 0">{{
                    scope.row.m6.n2
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="m7" label="第7天" width="76">
            </el-table-column>
            <el-table-column prop="m8" label="第8天" width="76">
            </el-table-column>
            <el-table-column prop="m9" label="第9天" width="76">
            </el-table-column>
            <el-table-column prop="m10" label="第10天" width="76">
            </el-table-column>
            <el-table-column prop="m11" label="第11天" width="76">
            </el-table-column>
            <el-table-column prop="m12" label="第12天" width="76">
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- 图3 -->
      <el-card shadow="never" class="chard-box">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_retaind_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">新增客户8周留存</b>
        </div>
        <span class="text">2021-06-28～2021-07-12过去8周新增客户的留存率</span>
        <div id="c3" style="margin-top: 30px"></div>
      </el-card>
      <!-- 图4 -->
      <el-card shadow="never" class="chard-box">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_retaind_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">活跃客户7日留存率</b>
        </div>
        <span class="text">2021-06-17～2021-06-30过去14天7日客户留存率</span>
        <div id="c4" style="margin-top: 30px"></div>
      </el-card>
      <!-- 图5 -->
      <el-card shadow="never" class="chard-box">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_retaind_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">活跃客户8周留存率</b>
        </div>
        <span class="text">2021-06-28～2021-07-12过去60天活跃客户的留存率</span>
        <div id="c5" style="margin-top: 30px"></div>
      </el-card>
      <!-- 图6 -->
      <el-card shadow="never" class="chard-box">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_retaind_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">活跃客户半年留存率</b>
        </div>
        <span class="text">2021-06-17～2021-06-30过去半年活跃客户留存率</span>
        <div id="c6" style="margin-top: 30px"></div>
      </el-card>
      <!-- 图7 -->
      <el-card shadow="never" class="chard-box last">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_retaind_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">明细表</b>
        </div>
        <div class="tab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- tab栏 -->
            <el-tab-pane label="访问留存" name="1"> </el-tab-pane>
            <el-tab-pane label="成交留存" name="2"> </el-tab-pane>
            <!-- 表格 -->
            <div class="my-table" style="margin-top: 20px">
              <el-table
                class="table2"
                :header-cell-style="{
                  background: '#eeeeee',
                  color: '#606266',
                }"
                :data="tableData"
                style="width: 100%"
                height="650"
                border
              >
                <el-table-column prop="date" :label="text.t1" width="150">
                </el-table-column>
                <el-table-column prop="num" :label="text.t2" width="120">
                </el-table-column>
                <el-table-column prop="m1" label="第1个月留存" width="120">
                  <template slot-scope="scope">
                    <span
                      :class="{
                        cellStyle: scope.row.m1 === 0 ? '' : true,
                      }"
                    >
                      <span v-if="scope.row.m1 == 0">{{ scope.row.m1 }}</span>
                      <span v-if="scope.row.m1 !== 0">{{
                        scope.row.m1.n1
                      }}</span>
                      <span v-if="scope.row.m1 !== 0">{{
                        scope.row.m1.n2
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="m2" label="第2个月留存" width="120">
                  <template slot-scope="scope">
                    <span
                      :class="{
                        cellStyle: scope.row.m2 === 0 ? '' : true,
                      }"
                      ><span v-if="scope.row.m2 == 0">{{ scope.row.m2 }}</span>
                      <span v-if="scope.row.m2 !== 0">{{
                        scope.row.m2.n1
                      }}</span>
                      <span v-if="scope.row.m2 !== 0">{{
                        scope.row.m2.n2
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="m3" label="第3个月留存" width="120">
                  <template slot-scope="scope">
                    <span
                      :class="{
                        cellStyle: scope.row.m3 === 0 ? '' : true,
                      }"
                      ><span v-if="scope.row.m3 == 0">{{ scope.row.m3 }}</span>
                      <span v-if="scope.row.m3 !== 0">{{
                        scope.row.m3.n1
                      }}</span>
                      <span v-if="scope.row.m3 !== 0">{{
                        scope.row.m3.n2
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="m4" label="第4个月留存" width="120">
                  <template slot-scope="scope">
                    <span
                      :class="{
                        cellStyle: scope.row.m4 === 0 ? '' : true,
                      }"
                      ><span v-if="scope.row.m4 == 0">{{ scope.row.m4 }}</span>
                      <span v-if="scope.row.m4 !== 0">{{
                        scope.row.m4.n1
                      }}</span>
                      <span v-if="scope.row.m4 !== 0">{{
                        scope.row.m4.n2
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="m5" label="第5个月留存" width="120">
                  <template slot-scope="scope">
                    <span
                      :class="{
                        cellStyle: scope.row.m5 === 0 ? '' : true,
                      }"
                      ><span v-if="scope.row.m5 == 0">{{ scope.row.m5 }}</span>
                      <span v-if="scope.row.m5 !== 0">{{
                        scope.row.m5.n1
                      }}</span>
                      <span v-if="scope.row.m5 !== 0">{{
                        scope.row.m5.n2
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="m6" label="第6个月留存" width="120">
                  <template slot-scope="scope">
                    <span
                      :class="{
                        cellStyle: scope.row.m6 === 0 ? '' : true,
                      }"
                      ><span v-if="scope.row.m6 == 0">{{ scope.row.m6 }}</span>
                      <span v-if="scope.row.m6 !== 0">{{
                        scope.row.m6.n1
                      }}</span>
                      <span v-if="scope.row.m6 !== 0">{{
                        scope.row.m6.n2
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="m7" label="第7个月留存" width="120">
                </el-table-column>
                <el-table-column prop="m8" label="第8个月留存" width="120">
                </el-table-column>
                <el-table-column prop="m9" label="第9个月留存" width="120">
                </el-table-column>
                <el-table-column prop="m10" label="第10个月留存" width="120">
                </el-table-column>
                <el-table-column prop="m11" label="第11个月留存" width="120">
                </el-table-column>
                <el-table-column prop="m12" label="第12个月留存" width="120">
                </el-table-column>
              </el-table>
            </div>
          </el-tabs>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <el-select
                style="width: 100px"
                v-model="def"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      def:'最近一年',
      //下拉表单
      options1: [{ value: "最近一年" },{ value: "近一个月" },{ value: "近3个月" },{ value: "近6个月" }],
      //切换底部tab的
      activeName: "1",
      //图表数据
      data: [
        { data: "6.14当周", name: "第1周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第1周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第1周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第1周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第1周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第1周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第1周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第1周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第2周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第2周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第2周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第2周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第2周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第2周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第2周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第2周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第3周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第3周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第3周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第3周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第3周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第3周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第3周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第3周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第4周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第4周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第4周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第4周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第4周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第4周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第4周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第4周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第5周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第5周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第5周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第5周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第5周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第5周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第5周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第5周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第6周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第6周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第6周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第6周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第6周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第6周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第6周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第6周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第7周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第7周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第7周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第7周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第7周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第7周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第7周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第7周", val: Math.random() * 0.4 },

        { data: "6.14当周", name: "第8周", val: Math.random() * 0.4 },
        { data: "6.21当周", name: "第8周", val: Math.random() * 0.4 },
        { data: "6.28当周", name: "第8周", val: Math.random() * 0.4 },
        { data: "7.5当周 ", name: "第8周", val: Math.random() * 0.4 },
        { data: "7.12当周", name: "第8周", val: Math.random() * 0.4 },
        { data: "7.19当周", name: "第8周", val: Math.random() * 0.4 },
        { data: "7.26当周", name: "第8周", val: Math.random() * 0.4 },
        { data: "8.2当周 ", name: "第8周", val: Math.random() * 0.4 },
      ],
      data2: [
        { data: "第1天", name: "6-17(三)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-17(三)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-17(三)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-17(三)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-17(三)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-17(三)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-17(三)", val: Math.random() * 1600 },

        { data: "第1天", name: "6-18(四)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-18(四)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-18(四)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-18(四)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-18(四)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-18(四)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-18(四)", val: Math.random() * 1600 },

        { data: "第1天", name: "6-19(五)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-19(五)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-19(五)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-19(五)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-19(五)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-19(五)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-19(五)", val: Math.random() * 1600 },

        { data: "第1天", name: "6-20(六)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-20(六)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-20(六)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-20(六)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-20(六)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-20(六)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-20(六)", val: Math.random() * 1600 },

        { data: "第1天", name: "6-21(日)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-21(日)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-21(日)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-21(日)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-21(日)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-21(日)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-21(日)", val: Math.random() * 1600 },

        { data: "第1天", name: "6-22(一)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-22(一)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-22(一)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-22(一)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-22(一)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-22(一)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-22(一)", val: Math.random() * 1600 },

        { data: "第1天", name: "6-23(二)", val: Math.random() * 1600 },
        { data: "第2天", name: "6-23(二)", val: Math.random() * 1600 },
        { data: "第3天", name: "6-23(二)", val: Math.random() * 1600 },
        { data: "第4天", name: "6-23(二)", val: Math.random() * 1600 },
        { data: "第5天", name: "6-23(二)", val: Math.random() * 1600 },
        { data: "第6天", name: "6-23(二)", val: Math.random() * 1600 },
        { data: "第7天", name: "6-23(二)", val: Math.random() * 1600 },
      ],
      data3: [
        { data: "3月", name: "第1月", val: Math.random() * 1600 },
        { data: "4月", name: "第1月", val: Math.random() * 1600 },
        { data: "5月", name: "第1月", val: Math.random() * 1600 },
        { data: "6月", name: "第1月", val: Math.random() * 1600 },
        { data: "7月", name: "第1月", val: Math.random() * 1600 },
        { data: "8月", name: "第1月", val: Math.random() * 1600 },

        { data: "3月", name: "第2月", val: Math.random() * 1600 },
        { data: "4月", name: "第2月", val: Math.random() * 1600 },
        { data: "5月", name: "第2月", val: Math.random() * 1600 },
        { data: "6月", name: "第2月", val: Math.random() * 1600 },
        { data: "7月", name: "第2月", val: Math.random() * 1600 },
        { data: "8月", name: "第2月", val: Math.random() * 1600 },

        { data: "3月", name: "第3月", val: Math.random() * 1600 },
        { data: "4月", name: "第3月", val: Math.random() * 1600 },
        { data: "5月", name: "第3月", val: Math.random() * 1600 },
        { data: "6月", name: "第3月", val: Math.random() * 1600 },
        { data: "7月", name: "第3月", val: Math.random() * 1600 },
        { data: "8月", name: "第3月", val: Math.random() * 1600 },

        { data: "3月", name: "第4月", val: Math.random() * 1600 },
        { data: "4月", name: "第4月", val: Math.random() * 1600 },
        { data: "5月", name: "第4月", val: Math.random() * 1600 },
        { data: "6月", name: "第4月", val: Math.random() * 1600 },
        { data: "7月", name: "第4月", val: Math.random() * 1600 },
        { data: "8月", name: "第4月", val: Math.random() * 1600 },

        { data: "3月", name: "第5月", val: Math.random() * 1600 },
        { data: "4月", name: "第5月", val: Math.random() * 1600 },
        { data: "5月", name: "第5月", val: Math.random() * 1600 },
        { data: "6月", name: "第5月", val: Math.random() * 1600 },
        { data: "7月", name: "第5月", val: Math.random() * 1600 },
        { data: "8月", name: "第5月", val: Math.random() * 1600 },

        { data: "3月", name: "第6月", val: Math.random() * 1600 },
        { data: "4月", name: "第6月", val: Math.random() * 1600 },
        { data: "5月", name: "第6月", val: Math.random() * 1600 },
        { data: "6月", name: "第6月", val: Math.random() * 1600 },
        { data: "7月", name: "第6月", val: Math.random() * 1600 },
        { data: "8月", name: "第6月", val: Math.random() * 1600 },
      ],

      //表格数据
      tableData: [
        {
          date: "总体",
          num: "304人",
          m1: { n1: "28人", n2: "100%" },
          m2: { n1: "28人", n2: "100%" },
          m3: { n1: "28人", n2: "100%" },
          m4: { n1: "28人", n2: "100%" },
          m5: { n1: "28人", n2: "100%" },
          m6: { n1: "28人", n2: "100%" },
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: { n1: "28人", n2: "100%" },
          m2: { n1: "28人", n2: "100%" },
          m3: { n1: "28人", n2: "100%" },
          m4: { n1: "28人", n2: "100%" },
          m5: { n1: "28人", n2: "100%" },
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: { n1: "28人", n2: "100%" },
          m2: { n1: "28人", n2: "100%" },
          m3: { n1: "28人", n2: "100%" },
          m4: { n1: "28人", n2: "100%" },
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: { n1: "28人", n2: "100%" },
          m2: { n1: "28人", n2: "100%" },
          m3: { n1: "28人", n2: "100%" },
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: { n1: "28人", n2: "100%" },
          m2: { n1: "28人", n2: "100%" },
          m3: 0,
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: { n1: "28人", n2: "100%" },
          m2: 0,
          m3: 0,
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: 0,
          m2: 0,
          m3: 0,
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: 0,
          m2: 0,
          m3: 0,
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: 0,
          m2: 0,
          m3: 0,
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
        {
          date: "2021.06.28",
          num: "28人",
          m1: 0,
          m2: 0,
          m3: 0,
          m4: 0,
          m5: 0,
          m6: 0,
          m7: 0,
          m8: 0,
          m9: 0,
          m10: 0,
          m11: 0,
          m12: 0,
        },
      ],
    };
  },
  computed:{
    text(){
      if(this.activeName == 1){
        return { t1:'访客时间',t2:'新访客客户数' }
      }else{
        return { t1:'成交时间',t2:'新成交客户数' }
      }
    }
  },
  mounted() {
    //图1
    this.init("c1", this.data, 370);
    //图2
    // 图3
    this.init("c3", this.data, 370);
    // 图4
    this.init("c4", this.data2, 370, 4);
    // 图5
    this.init("c5", this.data, 370);
    // 图6
    this.init("c6", this.data3, 370, 4);
    // 图7
  },
  methods: {
    //折线图
    init(id, data, height, type) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 300,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });

      // 处理Y轴的数据
      if (type == 4) {
        chart.scale("val", {
          min: 0,
          max: 1600,
        });

        chart.axis("val", {
          label: {
            formatter: (val) => {
              return val;
            },
          },
        });
      } else {
        chart.scale("val", {
          min: 0,
          max: 0.4,
        });

        chart.axis("val", {
          label: {
            formatter: (val) => {
              return val * 10 + "%";
            },
          },
        });
      }
      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: true,
      });
      chart.legend({
        //    layout:'vertical',
        flipPage: false, //图例不分页
        position: "bottom",
      });

      chart
        .line()
        .position("data*val")
        .shape("smooth")
        .color("name", [
          "#5B8FF9",
          "#5AD8A6",
          "#5D7092",
          "#F6BD16",
          "#E8684A",
          "#6DC8EC",
          "#9270CA",
          "#FF9D4D",
        ]);

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
    //点击tab事件
    handleClick(tab) {
      this.activeName = tab.name;
    },
    //动态修改单元格样式
    // addClass({ row, column, rowIndex, columnIndex }) {
    //       if(row.m1 !== 0  && columnIndex>1 ){
    //           return `background:#90B5FF;color:#081BA9;`
    //       }else{
    //         return
    //       }

    // },
  },
};
</script>

<style lang="less">
.keep {
  .my-chard {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .chard-box {
      margin-top: 20px;
      width: 49%;
      height: 480px;
      .fl {
        font-size: 16px;
        display: flex;
        align-items: center;
        b {
          margin-left: 10px;
        }
        img {
          width: 24px;
        }
      }
      .text {
        display: block;
        margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    .last {
      width: 98%;
      height: 800px;
    }
    .tab {
      position: relative;
      .el-tabs__nav-wrap::after {
        display: none;
      }
      .fr {
        // float: right;
        position: absolute;
        right: 0;
        top: 0;
        color: #999999;
        font-size: 12px;
        p {
          img {
            width: 16px;
            vertical-align: middle;
            //   margin-right: 10px;
          }
        }
        .my-select {
          margin-left: 10px;
        }
      }
    }
    .table1 {
      td {
        margin: 0;
        padding: 0;
        width: 76px;
      }
      .cell {
        text-align: center;
        padding-left: 1px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        width: 76px;
        padding-right: 0;
      }
      .el-table__row {
        height: 60px;
      }
      .cellStyle {
        display: inline-block;
        width: 76px;
        height: 60px;
        background-color: #90b5ff;
        text-align: center;
        color: #0013a5;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    .table2 {
      .el-table__header tr,
      .el-table__header th .cell {
        padding: 0;
        font-weight: 500 !important;
      }
      td {
        margin: 0;
        padding: 0;
      }
      .cell {
        text-align: center;
        padding-left: 1px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }
      .el-table__row {
        height: 60px;
      }
      .cellStyle {
        display: inline-block;
        width: 120px;
        height: 60px;
        background-color: #90b5ff;
        text-align: center;
        color: #0013a5;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
}
</style>